import moment from 'moment';
//import axios from 'axios';

//Obtiene una lista de días feriados y un formato de fecha
/*export function getDiasFeriados(){
    axios({
        method: 'get',
        url: '/api/plazoFijo/diasFeriados'
    }).then((response) => {
        if (response.data.statusCode === "200") {
        this.setState({dataDiasFeriados:response.data});
        return response.data;
        } else {
            this.props.history.push('/plazo-fijo/error');
        }
    }).catch(error => {
        this.props.history.push('/plazo-fijo/error');
    });
}*/

//Toma un formato de fecha y un rango de días feriados y verifica que el día actual sea hábil
export function esFeriado(formato,dias){
    let result=false;
    const hoy=moment().dayOfYear();
    dias.forEach(dia=>{          
      let diaX=moment(dia,formato).dayOfYear();
      let cond=(hoy===diaX);
      if(cond){
        result=true;
        return;
      }
    });
    return result;
}
//Verifica que el día actual sea un día de semana
export function esDiaDeSemana(){
    return moment().days() < 6;
}


// WEBPACK FOOTER //
// ./src/components/PlazoFijo/Utils/CalendarUtils.js